// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".activity-log-value-cell {\n    width: 25%;\n}\n\n.activity-log-info-cell {\n    max-width: 200px;\n}", "",{"version":3,"sources":["webpack://src/app/pages/orders/ActivityLogTab/style.css"],"names":[],"mappings":"AAAA;IACI,UAAA;AACJ;;AAEA;IACI,gBAAA;AACJ","sourcesContent":[".activity-log-value-cell {\n    width: 25%\n}\n\n.activity-log-info-cell {\n    max-width: 200px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
